/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How accurate is it?`)
};

const es_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué precisión tiene?`)
};

const de_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie genau ist es?`)
};

const nl_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe nauwkeurig is het?`)
};

const fr_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est sa précision ?`)
};

const it_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto è preciso?`)
};

const pt_br2_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a precisão dela?`)
};

const pt_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o grau de precisão?`)
};

const ja_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精度はどのくらいですか?`)
};

const zh_ruler_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它有多精确？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_faq_q2", locale)
	if (locale === "en") return en_ruler_faq_q2(inputs)
	if (locale === "es") return es_ruler_faq_q2(inputs)
	if (locale === "de") return de_ruler_faq_q2(inputs)
	if (locale === "nl") return nl_ruler_faq_q2(inputs)
	if (locale === "fr") return fr_ruler_faq_q2(inputs)
	if (locale === "it") return it_ruler_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_faq_q2(inputs)
	if (locale === "pt") return pt_ruler_faq_q2(inputs)
	if (locale === "ja") return ja_ruler_faq_q2(inputs)
	return zh_ruler_faq_q2(inputs)
};